import React, { useState } from 'react';
import { webhookEventOptions } from '../../../mocks/settings';

/**
 * Outbound webhook composer (T10.2). URL must be https; at least one event
 * must be subscribed. Mirrors the validation the backend will enforce.
 */
function WebhookForm({ onSubmit }) {
  const [label, setLabel] = useState('');
  const [url, setUrl] = useState('');
  const [events, setEvents] = useState([]);
  const [error, setError] = useState('');

  const toggleEvent = (event) => {
    setEvents((current) => (
      current.includes(event)
        ? current.filter((entry) => entry !== event)
        : [...current, event]
    ));
  };

  const handleSubmit = (formEvent) => {
    formEvent.preventDefault();
    if (!label.trim() || !url.trim()) {
      setError('Label and URL are required.');
      return;
    }
    if (!/^https:\/\//.test(url.trim())) {
      setError('Webhook URLs must use https.');
      return;
    }
    if (!events.length) {
      setError('Subscribe to at least one event.');
      return;
    }
    onSubmit({ label: label.trim(), url: url.trim(), events });
    setLabel('');
    setUrl('');
    setEvents([]);
    setError('');
  };

  return (
    <form className="settings-webhook-form" onSubmit={handleSubmit}>
      <div className="settings-form-grid">
        <div className="settings-field">
          <label htmlFor="webhook-label">Label</label>
          <input
            id="webhook-label"
            onChange={(event) => setLabel(event.target.value)}
            placeholder="Ops incident bridge"
            value={label}
          />
        </div>
        <div className="settings-field">
          <label htmlFor="webhook-url">Endpoint URL</label>
          <input
            id="webhook-url"
            onChange={(event) => setUrl(event.target.value)}
            placeholder="https://hooks.example.com/agi"
            value={url}
          />
        </div>
      </div>
      <fieldset className="settings-events">
        <legend>Events</legend>
        {webhookEventOptions.map((event) => (
          <label className="settings-check" key={event}>
            <input
              checked={events.includes(event)}
              onChange={() => toggleEvent(event)}
              type="checkbox"
            />
            <code>{event}</code>
          </label>
        ))}
      </fieldset>
      {error && <div className="auth-error" role="alert">{error}</div>}
      <button className="portal-primary-button" type="submit">Add webhook</button>
    </form>
  );
}

export default WebhookForm;
